import BlueButton from "../../../common/BlueButton/BlueButton.js";
import { useTranslation } from "react-i18next";
import "./middleDisplay.css";

const MiddleDisplay = () => {
    const { t } = useTranslation("homePage");
    // To replace the memes in the middle view replace the files
    // in the public folder named memeDisplayComponent1.png, ..2.png, ..3.png, ..4.png

    return (
        <>
            <div className="displayComponentHomePageMiddleContainer">
                <div className="displayComponentHomePageDescriptionContainer">
                    <div className="displayComponentHomePageDescriptionTextContainer">
                        <fieldset className="displayComponentHomePageDescriptionTitleLegend">
                            <legend className="displayComponentHomePageDescriptionTitleLegend">
                                {t("middleDisplayTitle1")}
                            </legend>
                            <div className="displayComponentHomePageDescriptionTextCard">
                                <p>{t("middleDisplayDescription1")}</p>
                                <div className="displayComponentHomeMemeDisplayComponentContainer">
                                    <img
                                        src="/memeDisplayComponent1.png"
                                        className="displayComponentHomeMemeDisplayComponent"
                                        alt="displayComponentHomeMemeDisplayComponent1"
                                    />
                                </div>
                            </div>
                        </fieldset>

                        <fieldset className="displayComponentHomePageDescriptionTitleLegend">
                            <legend className="displayComponentHomePageDescriptionTitleLegendRight">
                                {t("middleDisplayTitle2")}
                            </legend>
                            <div className="displayComponentHomePageDescriptionTextCardReverse">
                                <div className="displayComponentHomeMemeDisplayComponentContainer">
                                    <img
                                        src="/memeDisplayComponent2.png"
                                        className="displayComponentHomeMemeDisplayComponent"
                                        alt="displayComponentHomeMemeDisplayComponen2"
                                    />
                                </div>
                                <p>{t("middleDisplayDescription2")}</p>
                            </div>
                        </fieldset>

                        <fieldset className="displayComponentHomePageDescriptionTitleLegend">
                            <legend className="displayComponentHomePageDescriptionTitleLegend">
                                {t("middleDisplayTitle3")}
                            </legend>
                            <div className="displayComponentHomePageDescriptionTextCard">
                                <p>{t("middleDisplayDescription3")}</p>
                                <div className="displayComponentHomeMemeDisplayComponentContainer">
                                    <img
                                        src="/memeDisplayComponent3.png"
                                        className="displayComponentHomeMemeDisplayComponent"
                                        alt="displayComponentHomeMemeDisplayComponent3"
                                    />
                                </div>
                            </div>
                        </fieldset>

                        <fieldset className="displayComponentHomePageDescriptionTitleLegend">
                            <legend className="displayComponentHomePageDescriptionTitleLegendRight">
                                {t("middleDisplayTitle4")}
                            </legend>
                            <div className="displayComponentHomePageDescriptionTextCardReverse">
                                <div className="displayComponentHomeMemeDisplayComponentContainer">
                                    <img
                                        src="/memeDisplayComponent4.png"
                                        className="displayComponentHomeMemeDisplayComponent"
                                        alt="displayComponentHomeMemeDisplayComponent4"
                                    />
                                </div>
                                <p>{t("middleDisplayDescription4")}</p>
                            </div>
                        </fieldset>
                    </div>

                    <div className="displayComponentHomePageDescriptionButtonInstall">
                        <a
                            href="https://www.twitch.tv/ext/vry90hirenzsmkptzdqlb152l7n5mk"
                            target="_blank"
                            rel="noreferrer"
                        >
                            <BlueButton
                                text={t("installButtonText")}
                                isLarge={true}
                                onClick={() => null}
                            />
                        </a>
                    </div>
                </div>
            </div>
        </>
    );
};

export default MiddleDisplay;
